import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Users, Target, Heart, Calendar } from 'lucide-react'

export function KeyMetricsGrid({ followers, totalPostsAnalyzed, postsPerDay, engagementRate, spanDays }: {
  followers: number
  totalPostsAnalyzed: number
  postsPerDay: number
  engagementRate: string
  spanDays: number
}) {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card className="relative overflow-hidden">
        <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-blue-400/20 to-transparent rounded-full -translate-y-4 translate-x-4" />
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Followers</CardTitle>
          <Users className="h-5 w-5 text-blue-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-blue-500">{followers.toLocaleString()}</div>
          <div className="flex items-center gap-1 mt-2">
            <div className="w-2 h-2 rounded-full bg-blue-500" />
            <p className="text-xs text-blue-600">Total audience</p>
          </div>
        </CardContent>
      </Card>

      <Card className="relative overflow-hidden">
        <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-green-400/20 to-transparent rounded-full -translate-y-4 translate-x-4" />
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Posts Analyzed</CardTitle>
          <Target className="h-5 w-5 text-green-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-green-500">{totalPostsAnalyzed}</div>
          <div className="flex items-center gap-1 mt-2">
            <div className="w-2 h-2 rounded-full bg-green-500" />
            <p className="text-xs text-green-600">Over {spanDays} days</p>
          </div>
        </CardContent>
      </Card>

      <Card className="relative overflow-hidden">
        <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-pink-400/20 to-transparent rounded-full -translate-y-4 translate-x-4" />
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Engagement Rate</CardTitle>
          <Heart className="h-5 w-5 text-pink-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-pink-500">{engagementRate}</div>
          <div className="flex items-center gap-1 mt-2">
            <div className="w-2 h-2 rounded-full bg-pink-500" />
            <p className="text-xs text-pink-600">Avg per post</p>
          </div>
        </CardContent>
      </Card>

      <Card className="relative overflow-hidden">
        <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-purple-400/20 to-transparent rounded-full -translate-y-4 translate-x-4" />
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Posts Per Day</CardTitle>
          <Calendar className="h-5 w-5 text-purple-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-purple-500">{postsPerDay}</div>
          <div className="flex items-center gap-1 mt-2">
            <div className="w-2 h-2 rounded-full bg-purple-500" />
            <p className="text-xs text-purple-600">Posting frequency</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default KeyMetricsGrid


